<template>
  <div class="page">
    <top-header></top-header>
    <!--<h1 class="mt-2 text-center">Smart City</h1>-->
    <b-container fluid>
      <b-row class="mt-3 mb-2">
        <b-col class="text-left">
          <h4>Manage Users</h4>
        </b-col>
        <b-col class="text-right">
          <b-button variant="dark" pill class="btn-shadow-g mr-2" @click="showAddModal()">Add User</b-button>
          <!-- <b-button variant="dark" pill class="btn-shadow-only mr-2" href="/user-roles">User Roles</b-button> -->
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col class="col-md-12 col-sm-12 col-xs-12">
          <div class="container-box">
            <b-row class="mt-4">
              <b-col class="text-left">
                <span class="mr-2">Show</span>
                <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                </b-form-select>
                <span class="ml-2">entries</span>
              </b-col>
              <b-col>
                <b-form-group
                  label="Filter"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                    </b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col lg="12">
                <b-table
                  show-empty
                  sticky-header
                  small
                  striped
                  outlined
                  id="my-table"
                  stacked="md"
                  :items="records"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filterIncludedFields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(actions)="row">
                    <b-button
                      pill
                      variant="info"
                      class="btn-shadow-only mr-1"
                      @click="updateGroup(row.item, row.index, $event.target)"
                      size="sm"
                      ><b-icon icon="pencil" font-scale="1"></b-icon
                    ></b-button>
                    <b-button
                      pill
                      variant="danger"
                      class="btn-shadow-only mr-1"
                      @click="deleteGroup(row.item)"
                      size="sm"
                      ><b-icon icon="trash" font-scale="1"></b-icon
                    ></b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-left">
                <span class="mr-2"
                  >Showing {{ currentPage }} to {{ perPage > records.length ? records.length : perPage }} of
                  {{ records.length }} entries</span
                >
              </b-col>
              <b-col>
                <b-pagination
                  v-model="currentPage"
                  pills
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="right"
                  size="sm"
                  prev-text="Prev"
                  next-text="Next"
                  first-number
                  last-number
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="edit-model"
      :title="selectedItem.id > 0 ? 'Edit User' : 'Add User'"
      size="md"
      ok-only
      @hidden="resetSelectedItem"
      @ok="modalSubmit"
    >
      <b-container fluid>
        <b-row class="mb-1">
          <b-col>
            <b-form-group
              label="Title"
              label-for="imei-input"
              label-cols="4"
              label-size="sm"
              label-align-sm="right"
              invalid-feedback="Title is required"
            >
              <b-form-input id="imei-input" v-model="selectedItem.username" required></b-form-input>
            </b-form-group>
            <b-form-group
              label="Email"
              label-for="imei-input"
              label-cols="4"
              label-size="sm"
              label-align-sm="right"
              invalid-feedback="Email is required"
            >
              <b-form-input id="imei-input" v-model="selectedItem.email" required></b-form-input>
            </b-form-group>
            <b-form-group
              label="Password"
              label-for="imei-input"
              label-cols="4"
              label-size="sm"
              label-align-sm="right"
              invalid-feedback="Email is required"
            >
              <b-form-input id="imei-input" v-model="selectedItem.password" required></b-form-input>
            </b-form-group>
            <b-form-group label="Dashboard" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
              <b-form-select v-model="selectedItem.dashboard">
                <b-form-select-option value="dashboard/waterlevel">Water Level</b-form-select-option>
                <b-form-select-option value="dashboard/pumps">Pumps</b-form-select-option>
                <b-form-select-option value="home">Pumps and Water Level</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Roles" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
              <b-form-select v-model="selectedItem.role">
                <b-form-select-option v-for="item in roles" v-bind:key="item.id" :value="item.id">{{
                  item.title
                }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Groups" label-cols="4" label-size="sm" label-align-sm="right">
              <b-form-checkbox-group
                v-model="selectedItem.groupids"
                name="cb"
                :options="groups"
                value-field="id"
                text-field="title"
              >
                <!--<b-form-checkbox v-for="item in groups" v-bind:key="item.id" :value="item.id">{{item.title}}</b-form-checkbox>-->
              </b-form-checkbox-group>
            </b-form-group>
            <b-form-group label="Status" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
              <b-form-select v-model="selectedItem.status">
                <b-form-select-option value="1">Enabled</b-form-select-option>
                <b-form-select-option value="0">Disabled</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
      <form ref="form" @submit.stop.prevent="handleSubmit"></form>
      <template v-slot:modal-footer="{ ok, close }">
        <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
        <b-button size="sm" variant="success" @click="ok()">{{ selectedItem.id > 0 ? "Update" : "Submit" }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Header from "@/components/HeaderMain.vue";

export default {
  name: "Login",
  components: {
    "top-header": Header,
  },
  mounted() {
    this.devices = "";
    this.groups = this.$session.get("user_info").groups;
    this.initload();
  },
  data() {
    var self = this;
    return {
      email: "",
      last_sync_time: "",
      url: this.$root.httpurl + "api-wms/users",
      insertUrl: this.$root.httpurl + "api-wms/add-user",
      updateUrl: this.$root.httpurl + "api-wms/update-user",
      deleteUrl: this.$root.httpurl + "api-wms/delete-user",
      networkfilter: -1,
      items: [],
      total_esr: 0,
      total_gsr: 0,
      connected_esr: 0,
      connected_gsr: 0,
      total_device: 0,
      total_device_on: 0,
      total_device_loss: 0,
      connected_devices: 0,
      total_controller: 0,
      total_controller_on: 0,
      total_controller_off: 0,
      total_controller_loss: 0,
      poweroff_devices: 0,
      dashboard_data: {},
      filteredrecords: [],
      total_load: 0,
      current_load: 0,
      selected_region: { state: self.$route.params.stateid },
      networkOptions: [
        { text: "All", value: -1 },
        { text: "Connected", value: 1 },
        { text: "Disconnected", value: 0 },
      ],
      roles: [],
      records: [],
      fields: [
        { key: "id", label: "ID.", class: "text-left" },
        { key: "username", label: "Username", sortable: true, sortDirection: "desc", class: "text-left" },
        { key: "role", label: "Role", sortable: true, class: "text-center" },
        // { key: "group", label: "Group", sortable: true, class: "text-left" },
        { key: "actions", label: "Actions", extra: 1, class: "text-center" },
      ],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      selectedItem: {
        id: 0,
        role: "",
        groupids: [],
        dashboard: "",
        email: "",
        password: "",
      },
      emptyItem: {
        id: 0,
        role: "",
        groupids: [],
        dashboard: "",
        email: "",
        password: "",
      },
      center: { lat: 0, lng: 0 },
      markers: [],
      places: [],
      currentPlace: null,
      infoWindowPos: null,
      infoWindowOpen: false,
      currentMarkerIndex: null,
      zoneinfo: { zoom: 22 },
      infoOptions: {
        content: "",
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    };
  },
  methods: {
    onFilterDevices() {
      this.filteredrecords = this.filterDevices(this.devices);
      this.totalRows = this.filteredrecords.length;
      this.currentPage = 1;
    },
    resetSelectedItem() {
      var self = this;
      self.selectedItem = Object.assign({}, self.emptyItem);
    },
    toogleMarkerInfoWindow(marker, index) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.infotext;
      if (this.currentMarkerIndex == index) {
        this.infoWindowOpen = !this.infoWindowOpen;
      } else {
        this.infoWindowOpen = true;
        this.currentMarkerIndex = index;
      }
    },
    addMarker(lat, lng, infotext, iconurl) {
      const marker = {
        lat: lat,
        lng: lng,
      };
      this.markers.push({
        position: marker,
        infotext: infotext,
        icon: {
          url: iconurl,
          size: { width: 35, height: 45, f: "px", b: "px" },
          scaledSize: { width: 35, height: 45, f: "px", b: "px" },
        },
      });
      //this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
      //this.places.push(this.currentPlace);
      this.center = marker;
      this.currentPlace = null;
    },
    showAddModal() {
      this.selectedItem = Object.assign({}, this.emptyItem);
      this.$root.$emit("bv::show::modal", "edit-model");
    },
    updateGroup(item, index, button) {
      item.groupids = item.group_id.split(",");
      this.selectedItem = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "edit-model", button);
    },
    chooseLocation(item) {
      this.$session.set("group_id", item.id);
      this.$session.set("logo", item.logo);
      this.$session.set("portal_name", item.portal_name);
      this.$router.push(item.dashboard);
    },
    deleteGroup(item) {
      var self = this;
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete group.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            self.axios
              .post(self.deleteUrl, {
                accesskey: self.$session.get("access_key"),
                deleteid: item.id,
              })
              .then(function(response) {
                if (response.data.error == 0 || response.data.error == "0") {
                  self.$session.get("user_info").groups = response.data.groups;
                  self.devices = response.data.groups;

                  self.$bvToast.toast(response.data.message, {
                    title: "Delete",
                    toaster: "b-toaster-bottom-right",
                    autoHideDelay: 5000,
                    variant: "warning",
                    solid: true,
                    appendToast: true,
                  });
                  self.initload();
                }
              })
              .catch(function(error) {
                alert(error);
              });
          } else {
            //alert('no '+item.id);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    modalSubmit(bvModalEvt) {
      var self = this;
      self.loading = true;
      bvModalEvt.preventDefault();

      var submitUrl = "";
      if (self.selectedItem.id == 0) {
        submitUrl = self.insertUrl;
      } else {
        submitUrl = self.updateUrl;
      }

      self.axios
        .post(submitUrl, {
          accesskey: self.$session.get("access_key"),
          data: self.selectedItem,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.$bvModal.hide("edit-model");
            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
            self.initload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    initload() {
      var self = this;
      self.loading = true;

      self.axios
        .post(self.url, {
          accesskey: self.$session.get("access_key"),
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.records = response.data.result.users;
            self.roles = response.data.result.roles;
            self.totalRows = self.records.length;

            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-color: "#FFF" !important;
  background-image: none !important;
}
.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}

.mt-xl {
  margin-top: 100px;
}
.btn-black {
  background-color: #000;
  color: #fff;
  padding: 6px 25px;
}
.info-box2 {
  display: block;
  min-height: 90px;
  background-color: #fff;
  width: 100%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-bottom: 15px;
}
</style>
